<template>
  <div class="discover-banner">
    <div class="background" :style="{ background: `url(${sectionData.field_5})` }"></div>
    <img :src="sectionData.field_6" class="mobile" />
    <div class="banner">
      <div class="text">
        <p class="textdetail title">{{ sectionData.field_1 }}</p>
        <p class="textdetail subtitle">{{ sectionData.field_2 }}</p>
        <div class="cta-section">
          <a :href="sectionData.field_4" class="discover-cta">{{ sectionData.field_3 }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "discover-banner",
  props: {
    section: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      sectionData: {
        items: [],
      },
    };
  },
  mounted() {
    try {
      this.sectionData = JSON.parse(this.section);
    } catch (error) {
      console.error("Error parsing section JSON:", error);
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile {
  display: none;
}
.discover-banner {
  width: 100%;
  height: 500px;
  position: relative;
  display: flex;
  align-items: center;
  background-color: black;
  .background {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-size: cover !important;
    background-position: center !important;
  }

  @media only screen and (max-width: 768px) {
    background-position: left !important;
    display: block;
    height: initial;
    background-image: none;
    .background {
      display: none;
    }
    .mobile {
      display: block;
      width: 100%;
    }
    .cta-section, .discover-cta {
      width: 100%;
    }
  }

  .banner {
    color: #fff;
    padding: 20px;
    flex: 1;
    position: relative;

    @media only screen and (max-width: 768px) {
      display: flex;
      flex-direction: column;
      align-self: center;
    }

    .text {
      text-align: left;
      margin-left: 50%;

      @media only screen and (max-width: 768px) {
        margin-left: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: left;
        text-align: left;
      }

      .textdetail {
        max-width: 650px;
        color: #FFFFFF;

        @media only screen and (max-width: 768px) {
          font-size: 24px;
        }
      }

      .title {
        font-family: 'trim-medium';
        margin-bottom: 0;
        font-size: 48px;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 46px;
        padding-bottom: 20px;
        
        @media only screen and (max-width: 768px) {
          line-height: 28px;
          font-size: 16px;
          text-align: left;
        }
      }

      .subtitle {
        font-family: 'trim-light';

        @media only screen and (max-width: 768px) {
          line-height: 22px;
          font-size: 14px;
          text-align: left;
        }
      }

      .cta-section {
        .discover-cta {
          text-transform: uppercase;
          color: white;
          border: 1px solid #025cb9;
          background-color: #025cb9;
          padding: 16px 30px;
          display: inline-block;
          margin-bottom: 25px;
          transition: 0.15s;

          font-family: "trim-regular";
          font-size: 16px;
          letter-spacing: 1.33px;
          line-height: 19px;
          text-align: center;

          &:hover {
            background-color: #004386;
            text-decoration: none;
          }
        }
      }
    }
  }

  .logo {
    position: absolute;
    bottom: 32px;
    right: 37px;
    max-width: 211px;
    max-height: 100px;

    @media only screen and (max-width: 768px) {
      display: none;
    }

  }
}
</style>
